import React, { useState, type ReactElement } from 'react';
import CoordinationClient from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { type IntlShape, FormattedMessage, injectIntl } from '@atlassian/jira-intl';

import { SpotlightDialogDeprecated } from '@atlassian/jira-servicedesk-itsm-onboarding-common/src/ui/spotlight-dialog/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import messages from './messages.tsx';

type StopFunction = () => void;
type CoordinationStopProviderProps = {
	stop: StopFunction;
	children: (arg1: StopFunction | undefined) => ReactElement;
};
type InternalProps = {
	projectKey: string;
} & { intl: IntlShape };

export const CoordinationStopProvider = ({ stop, children }: CoordinationStopProviderProps) =>
	children(stop);

CoordinationStopProvider.defaultProps = {
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	stop: () => {},
};

export const JSD_KB_HUB_MULTI_LINKED_SPACES_TOUR = 'jsd-kb-hub-multi-linked-spaces-tour';

const KnowledgeHubMultiSpacesChangeboarding = ({ intl, projectKey }: InternalProps) => {
	const isAdmin = useIsAdmin();
	const [showChangeboardingMessage, toggleChangeboardingMessage] = useState<boolean>(true);
	const settingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`;
	const stopTour = (stopFn: StopFunction | null | undefined, changeRoute: boolean) => {
		toggleChangeboardingMessage(false);
		stopFn && stopFn();
		if (changeRoute) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			setTimeout(() => window.open(settingsUrl, '_self'), 1000);
		}
	};

	const description = (
		<FormattedMessage
			{...(isAdmin ? messages.dialogTitleAdmin : messages.dialogTitleAgent)}
			values={{
				bold_space_name: <b>{intl.formatMessage(messages.linkedSpacesText)}</b>,
			}}
		/>
	);
	const learnMoreLinkText = isAdmin ? intl.formatMessage(messages.settingsUrlText) : '';
	const gotItButtonText = intl.formatMessage(messages.buttonText);
	return (
		<CoordinationClient messageId={JSD_KB_HUB_MULTI_LINKED_SPACES_TOUR}>
			<CoordinationStopProvider>
				{(stop) =>
					// @ts-expect-error - TS2322 - Type 'false | Element' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
					showChangeboardingMessage && (
						<SpotlightDialogDeprecated
							learnMoreLinkText={learnMoreLinkText}
							// eslint-disable-next-line jira/react-no-inline-function-prop
							onConfirm={() => stopTour(stop, false)}
							gotItButtonText={gotItButtonText}
							description={description}
							buttonOverrideProps={{
								target: '_self',
								onClick: () => stopTour(stop, true),
							}}
						/>
					)
				}
			</CoordinationStopProvider>
		</CoordinationClient>
	);
};

export default injectIntl(KnowledgeHubMultiSpacesChangeboarding);
